import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_BOX_O_LINKS_IN_VIEWPORT = 'classpass/venue-filters/SET_BOX_O_LINKS_IN_VIEWPORT';
var SET_ENABLED_MOBILE_FILTERS = 'classpass/venue-filters/SET_ENABLED_MOBILE_FILTERS';
var SET_KEY = 'classpass/venue-filters/SET_KEY';
var SET_MSA_ID = 'classpass/venue-filters/SET_MSA_ID';
var SET_FILTERS_HIDDEN = 'classpass/venue-filters/SET_FILTERS_HIDDEN';
var SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT = 'classpass/venue-filters/SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT';
var TOGGLE_CLASS_VISIBILITY_FOR_VENUE = 'classpass/venue-filters/TOGGLE_CLASS_VISIBILITY_FOR_VENUE';
export var setBoxOLinksInViewport = function setBoxOLinksInViewport(boxOLinksInViewport) {
  return {
    type: SET_BOX_O_LINKS_IN_VIEWPORT,
    data: {
      key: 'boxOLinksInViewport',
      value: boxOLinksInViewport
    }
  };
};
export var setEnabledMobileFilters = function setEnabledMobileFilters(filters) {
  return {
    type: SET_ENABLED_MOBILE_FILTERS,
    data: {
      key: 'enabledMobileFilters',
      value: filters
    }
  };
};
export var setKey = function setKey(key) {
  return {
    type: SET_KEY,
    data: {
      key: 'venueKey',
      value: key
    }
  };
};
export var setMsaId = function setMsaId(msaId) {
  return {
    type: SET_MSA_ID,
    data: {
      key: 'msaId',
      value: msaId
    }
  };
};
export var setFiltersHidden = function setFiltersHidden(filtersHidden) {
  return {
    type: SET_FILTERS_HIDDEN,
    data: {
      key: 'filtersHidden',
      value: filtersHidden
    }
  };
};
export var setTapTouchButtonsInViewport = function setTapTouchButtonsInViewport(tapTouchButtonsInViewport) {
  return {
    type: SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT,
    data: {
      key: 'tapTouchButtonsInViewport',
      value: tapTouchButtonsInViewport
    }
  };
};
export var toggleClassVisibilityForVenue = function toggleClassVisibilityForVenue(venueId, forceVisibility) {
  return {
    type: TOGGLE_CLASS_VISIBILITY_FOR_VENUE,
    data: {
      venueId: venueId,
      forceVisibility: forceVisibility
    }
  };
};

var initialState = function initialState() {
  return {
    boxOLinksInViewport: false,
    enabledMobileFilters: [],
    filtersHidden: true,
    tapTouchButtonsInViewport: false,
    venueIdWithClassesExpanded: {}
  };
};

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_BOX_O_LINKS_IN_VIEWPORT:
    case SET_KEY:
    case SET_MSA_ID:
    case SET_ENABLED_MOBILE_FILTERS:
    case SET_FILTERS_HIDDEN:
    case SET_TAP_TOUCH_BUTTONS_IN_VIEWPORT:
      return _objectSpread({}, state, _defineProperty({}, action.data.key, action.data.value));

    case TOGGLE_CLASS_VISIBILITY_FOR_VENUE:
      {
        var _action$data = action.data,
            venueId = _action$data.venueId,
            forceVisibility = _action$data.forceVisibility;

        var nextState = _objectSpread({}, state, {
          venueIdWithClassesExpanded: _objectSpread({}, state.venueIdWithClassesExpanded)
        });

        if (forceVisibility === false) {
          delete nextState.venueIdWithClassesExpanded[venueId];
        } else if (forceVisibility === true) {
          nextState.venueIdWithClassesExpanded[venueId] = true;
        } else if (state.venueIdWithClassesExpanded[venueId]) {
          delete nextState.venueIdWithClassesExpanded[venueId];
        } else {
          nextState.venueIdWithClassesExpanded[venueId] = true;
        }

        return nextState;
      }

    default:
      return state;
  }
}